<template>
  <div id="jumbotron">
    <div class="container">
      <h1>English Classes<br>Adults</h1>
    </div>
  </div>

  <div class="container pt-5">
    <div class="row m-0">
      <div class="col-12 col-md-4 col-lg-3">
        <h2 class="text-primary mb-4">Course structure</h2>
      </div>
      <div class="col-12 col-md-8 col-lg-9">
        <p>We recognise that adult learners, especially those who work, have so many demands on their time that it can sometimes be hard to commit to regular classes.</p>

        <p>For this reason, here at English Matters we offer you a unique opportunity to learn at your own pace and in accordance with your own particular needs.</p>

        <p>You can choose one (or more) of 2 different options:</p>

        <ul>
          <li>Private <strong>one-on-one lessons</strong>, completely tailored to each individual student’s needs – anything from elementary pronunciation or conversation classes to advanced business writing. We can also generally provide these individual sessions at a time and day of your choosing. We have the most affordable rates for a package of 12 lessons at RM165 per private class. Terms & Conditions apply.</li>
          <li>Class sessions for <strong>groups of 4 or more students</strong>. So if you and your friends or work colleagues want to come together to improve your English, then get in touch with us for more information.</li>
        </ul>

        <p>
          Please 
          <router-link to="/contact">contact us</router-link>
          for our latest rates customized to your specific requirements.
        </p>

        <div id="classPhotos" class="row m-0 mt-5">
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/Classes+Adults-1.webp" alt="English Class for Adults" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/Classes+Adults-2.webp" alt="English Class for Adults" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/Classes+Adults-3.webp" alt="English Class for Adults" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/Classes+Adults-4.webp" alt="English Class for Adults" class="w-100 rounded"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-color py-5 mt-5">
    <div class="container">
      <div class="row m-0">
        <div class="col-12 col-md-3 col-lg-3">
          <h2 class="text-primary mb-4">Corporate Solutions</h2>
        </div>
        <div class="col-12 col-md-7 col-lg-7">
          <ul>
            <li>English Matters is HRDCorp (formerly HRDF) certified.</li>
            <li>We are experienced corporate trainers, and look to provide that unique personal touch for our corporate clients just as much as for our individual students. With particular expertise in <strong>Business Writing Courses</strong> and <strong>Communication Skills</strong> classes, we can tailor our courses to your company’s needs.</li>
            <li>Please <router-link to="/contact">contact us</router-link> now to find out how we can help you and your business.</li>
          </ul>
        </div>
        <div class="col-12 col-md-2 col-lg-2 text-center text-md-end">
          <img id="hrdfLogo" src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/hrdcorp-trainer.webp" alt="Classes are HRDF Claimable" class="w-100">
        </div>
      </div>
    </div>
  </div>

  <ContactUs />
</template>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }

h1 { font-size: 3.5em; }
h2 { font-size: 3em; }

.bg-color {
  background-color: #F4F3F9;
}

#classPhotos img {
  max-width: 225px;
  height: auto;
  object-fit: cover; 
  aspect-ratio: 1 / 1;
  margin-bottom: 20px;
}

li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

#hrdfLogo {
  max-width: 200px;
}
</style>

<script>
import ContactUs from '../components/ContactUs.vue';
export default {
  components: { ContactUs }
}
</script>